
import './App.css';

import Header from './Components/Header/Header';
import Food from './Components/Food/Food';

function App() {
 
  return (
    <div className="App">
      <Header></Header>
      <Food></Food>
      
      
    </div>
  );
}

export default App;
